<template>
    <div>
        <div
            :model="model"
            :action="action"
            :id="id"
            :root-config="rootConfig"
            :config="config"
            :is="activeComponent"
            :siteId="siteId"
            :permitted-sites-config="permittedSitesConfig"
        ></div>
    </div>
</template>

<script>
import ElementUI from 'element-ui';
import Vue from 'vue';
import VueCrudIndex from './VueCrudIndex.vue';
import VueCrudEdit from './VueCrudEdit.vue';
import VueCrudNew from './VueCrudNew.vue';
import VueCrudPrint from './VueCrudPrint.vue';
import api from '../libs/api';
import 'vue-wysiwyg/dist/vueWysiwyg.css';
import locale from 'element-ui/lib/locale/lang/en';

Vue.use(ElementUI, { locale });

export default {
    name: 'v-crud',

    props: [
        'model',
        'config',
        'rootConfig',
        'action',
        'id',
        'siteId',
        'permittedSitesConfig',
    ],

    data() {
        return {
            activeComponent: 'v-crud-index',
            params: {},
        };
    },

    components: {
        'v-crud-index': VueCrudIndex,
        'v-crud-new': VueCrudNew,
        'v-crud-edit': VueCrudEdit,
        'v-crud-print': VueCrudPrint,
    },

    watch: {
        action() {
            this.activeComponent = 'v-crud-' + this.action;
        },

        model() {
            this.setApi();
        },
    },

    created() {
        this.setApi();
        this.activeComponent = 'v-crud-' + this.action;
    },

    methods: {
        setApi() {
            api.init = (resource) => {
                return this.$resource(
                    this.rootConfig.endPoint + '/' + resource,
                    {},
                    {},
                    { headers: this.rootConfig.headers }
                );
            };

            api.res = api.init(this.config.resource);
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// VueCrud.vue?8b513d28